import { io } from "socket.io-client";
import { getPersistedAuthToken } from "./tokenUtils";

/**
 * The socket.io `auth` option for a signed-in customer's socket: presents the
 * stored access token on every connect and reconnect.
 *
 * WHY (16 Oct 2026). The server lets a socket into a customer's rooms
 * (payment:, paymentStatus:, user:, orderRoom:) only with that customer's
 * token. Before, anyone who knew a customer id could listen to their payments
 * and whole orders, addresses and phone numbers included.
 */
export const userSocketAuth = (cb) => {
  let token = null;
  try {
    token = getPersistedAuthToken();
  } catch {
    token = null;
  }
  cb(token ? { token } : {});
};

/** A socket for one customer page, carrying the customer's token. */
export const createUserSocket = (options = {}) =>
  io(process.env.REACT_APP_SOCKET_URL, {
    transports: ["websocket", "polling"],
    ...options,
    auth: userSocketAuth,
  });

export default createUserSocket;
